import { render, staticRenderFns } from "./ImageSize.vue?vue&type=template&id=11268886"
import script from "./ImageSize.vue?vue&type=script&lang=js"
export * from "./ImageSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports